/* eslint-disable ts/ban-ts-comment */
export function useDebounce<
  FunctionType extends (
    ...args: Parameters<FunctionType>
  ) => ReturnType<FunctionType>,
>(fn: FunctionType, timeout = 300) {
  let timer: NodeJS.Timeout
  return (...args: Parameters<FunctionType>) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      // @ts-expect-error
      fn.apply(this, args)
    }, timeout)
  }
}
